module.exports = __webpack_public_path__ + "static/maidan-sm-4864afdc61c9119df2282c09dad3e80c.jpg";